<template>
  <div>
    <Div v-if="transaction.limit">
      <h4>Ваш лимит: {{ transaction.limit | spaceBetweenNumber }} UZS</h4>
    </Div>

    <div class="install-control">
      <button
        v-if="!transaction.limit"
        @click="getLimit"
        class="btn btn-success"
      >
        {{ "check_limit" | setText("Проверить лимит") }}
      </button>
      <button
        v-if="transaction.limit"
        @click="getStatus"
        class="btn btn-success"
      >
        {{ "check_status" | setText("Проверить статус") }}
      </button>
      <button v-if="level && level != 6" @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  components: {},
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    send() {
      let data = {
        app_id: this.transaction.exchange_id
          ? this.transaction.exchange_id
          : this.value.data.app_id,
      };

      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}application/scoring`,
        method: "POST",
        data: data,
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            // this.$emit("setStep", "contract-purchase");
            // this.createTransaction({
            //   step: "contract-purchase",
            // });
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },
    getLimit() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}application/limit/${
          this.transaction.exchange_id
            ? this.transaction.exchange_id
            : this.value.data.app_id
        }`,
        method: "GET",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            console.log("LIMIT", response.data);

            this.createTransaction({ limit: response.data.data.limit });
            this.$emit("input", response.data);
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },
    getStatus() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}application/status/${
          this.transaction.exchange_id
            ? this.transaction.exchange_id
            : this.value.data.app_id
        }`,
        method: "GET",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            console.log("STATUS", response.data);
            this.level = response.data.data.level;

            if (this.level == 6) {
              this.$emit("setStep", "contract-purchase");
            }

            this.$emit("input", response.data);
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },
  },
  data() {
    return {
      limit: null,
      level: null,
    };
  },
};
</script>

